/**
 * Meta Pixel bootstrap + helpers (pixel ID below).
 *
 * The pixel initializes from the app bundle instead of an inline <script>
 * in index.html: the site's CSP (script-src 'self' …, no 'unsafe-inline')
 * blocks inline scripts in production, so Meta's standard snippet would be
 * silently ignored. initMetaPixel() is the equivalent bootstrap — it
 * creates the official queueing stub, loads fbevents.js (allowed via
 * connect.facebook.net in the CSP), and fires the initial PageView.
 * The <noscript> fallback lives at the top of <body> in index.html.
 */

const PIXEL_ID = '1364859562184967';

interface MetaPixelFn {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: MetaPixelFn;
  loaded: boolean;
  version: string;
}

declare global {
  interface Window {
    fbq?: MetaPixelFn;
    _fbq?: MetaPixelFn;
  }
}

/** Idempotent pixel bootstrap; safe to call on every app mount. */
export const initMetaPixel = () => {
  try {
    if (window.fbq) return;

    const fbq = ((...args: unknown[]) => {
      if (fbq.callMethod) {
        fbq.callMethod(...args);
      } else {
        fbq.queue.push(args);
      }
    }) as MetaPixelFn;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);

    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  } catch {
    // Analytics must never break the page
  }
};

export const trackMetaPixelEvent = (event: string, params?: Record<string, unknown>) => {
  try {
    if (params) {
      window.fbq?.('track', event, params);
    } else {
      window.fbq?.('track', event);
    }
  } catch {
    // Never let analytics break the page
  }
};

export const trackMetaPixelPageView = () => trackMetaPixelEvent('PageView');
